import axios from 'axios';

export default function setAuthToken(token) {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        sessionStorage.setItem("auth-token", token)
    } else {
        delete axios.defaults.headers.common["Authorization"];        
        sessionStorage.removeItem("auth-token")
    }
}


// WEBPACK FOOTER //
// ./src/utils/setAuthToken.js